import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StartYourJourney() {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="start-journey-page">
            <div className="start-journey-heading">
                <h1 className="page-title">
                    Start Your Journey 🚀
                </h1>
                <p className="page-sub">
                    Every chapter has three difficulty levels. Each level has multiple frames.
                    <br />
                    Master more frames to strengthen your understanding and unlock your progress.
                </p>
            </div>

            <div className="start-journey-card">
                {/* LEFT SIDE */}
                <div className="start-journey-left">
                    <div className="start-journey-chapter-header">
                        <div className="start-journey-chapter-icon-bg">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"></path></svg>
                        </div>
                        <span className="start-journey-chapter-name">Quadratic Equations</span>
                    </div>

                    <div className="start-journey-level-row lot">
                        <div className="start-journey-level-badge lot">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22V12" /><path d="M12 12C12 12 12 6 18 4C18 4 18 10 12 12Z" /><path d="M12 12C12 12 12 6 6 4C6 4 6 10 12 12Z" /></svg>
                        </div>
                        <div className="start-journey-level-info">
                            <div className="start-journey-level-name lot">Learn (LOT)</div>
                            <div className="start-journey-level-desc">Build strong fundamentals.</div>
                        </div>
                        <div className="start-journey-frames">
                            {[1, 2, 3, 4, 5].map((n) => (
                                <div key={n} className="start-journey-frame-bubble lot">{n}</div>
                            ))}
                            <div className="start-journey-frame-bubble lot">···</div>
                        </div>
                    </div>

                    <div className="start-journey-connector">
                        <svg width="12" height="24" viewBox="0 0 12 24" fill="none"><path d="M6 2L6 22M6 2L3 5M6 2L9 5M6 22L3 19M6 22L9 19" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 3" /></svg>
                    </div>

                    <div className="start-journey-level-row mot">
                        <div className="start-journey-level-badge mot">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /><path d="M5 19l4-4" /></svg>
                        </div>
                        <div className="start-journey-level-info">
                            <div className="start-journey-level-name mot">Apply (MOT)</div>
                            <div className="start-journey-level-desc">Solve multi-step problems.</div>
                        </div>
                        <div className="start-journey-frames">
                            {[1, 2, 3, 4, 5].map((n) => (
                                <div key={n} className="start-journey-frame-bubble mot">{n}</div>
                            ))}
                            <div className="start-journey-frame-bubble mot">···</div>
                        </div>
                    </div>

                    <div className="start-journey-connector">
                        <svg width="12" height="24" viewBox="0 0 12 24" fill="none"><path d="M6 2L6 22M6 2L3 5M6 2L9 5M6 22L3 19M6 22L9 19" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 3" /></svg>
                    </div>

                    <div className="start-journey-level-row hot">
                        <div className="start-journey-level-badge hot">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" /></svg>
                        </div>
                        <div className="start-journey-level-info">
                            <div className="start-journey-level-name hot">Challenge (HOT)</div>
                            <div className="start-journey-level-desc">Tackle exam-level questions.</div>
                        </div>
                        <div className="start-journey-frames">
                            {[1, 2, 3, 4, 5].map((n) => (
                                <div key={n} className="start-journey-frame-bubble hot">{n}</div>
                            ))}
                            <div className="start-journey-frame-bubble hot">···</div>
                        </div>
                    </div>

                    <div className="start-journey-frame-legend">
                        <div className="start-journey-legend-icon-bg">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
                        </div>
                        <span>Each number is a Frame.</span>
                    </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="start-journey-right">
                    <div className="start-journey-how-title">Here's how it works</div>

                    <div className="start-journey-how-item">
                        <div className="start-journey-how-icon blue">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        </div>
                        <div>
                            <div className="start-journey-how-name">Go to a chapter</div>
                            <div className="start-journey-how-desc">
                                Choose a chapter and a difficulty level that matches your goal.
                            </div>
                        </div>
                    </div>

                    <div className="start-journey-how-item">
                        <div className="start-journey-how-icon purple">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1" fill="white"/></svg>
                        </div>
                        <div>
                            <div className="start-journey-how-name">Start attempting frames</div>
                            <div className="start-journey-how-desc">
                                Solve frames one by one. Get guidance when you need help.
                            </div>
                        </div>
                    </div>

                    <div className="start-journey-how-item">
                        <div className="start-journey-how-icon green">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/><path d="M19 9h-5"/><path d="M19 9v5"/></svg>
                        </div>
                        <div>
                            <div className="start-journey-how-name">Master with consistency</div>
                            <div className="start-journey-how-desc">
                                Use <em style={{ fontFamily: "'Caveat', cursive", color: "var(--primary)", fontStyle: "normal" }}>Try Similar</em> to generate new questions.
                                Improve your accuracy and reduce hint dependence to master each frame.
                            </div>
                        </div>
                    </div>

                    <button
                        className="primary-button start-journey-cta-btn"
                        onClick={() => navigate("/chapters", { replace: true })}
                    >
                        Choose Your First Chapter →
                    </button>
                </div>

            </div>
        </div>
    );
}